(function () {
'use strict';

angular
    .module('employeeRoutes', [
        'employeeControllers'
    ])
    .config(routeur);

    routeur.$inject = ['$stateProvider', '$urlRouterProvider'];

    function routeur($stateProvider, $urlRouterProvider) {
        $stateProvider
             .state('profile', {
                 url: '/employee/',
                 template: '<div ui-view></div>',
                 controller: 'EmployeeAllProfilesController',
                 resolve: {
                     authenticatedUser: ['authenticatedUserService', function (service) {
                         return service.getAuthenticatedUser();
                     }]
                 }
             })

            .state('profile.employee', {
                url: '{EmployeeID:int}/',
                resolve: {
                    employee: ['$stateParams', 'employeeService', function ($stateParams, service) {
                        return service
                            .getEmployeeBasicInfos($stateParams.EmployeeID, false) // false = no caching
                            .then(function (response) { return response.data; });
                    }],
                    fromDateWhenArrivalRequest: ['appParamService', function (service) {
                        return service.getAppParam('FromDateWhenArrivalRequest');
                    }],
                },
                views: {
                    '': {
                        templateUrl: require('./employee.tpl.html'),
                        controller: 'EmployeeController',
                    },
                    'sidebar@profile.employee': {
                        templateUrl: require('./employeeSidebar.tpl.html'),
                        controller: 'EmployeeSidebarController',
                    },
                    'mainContent@profile.employee': {
                        templateUrl: require('./employeeSummary.tpl.html'),
                        controller: 'EmployeeSummaryController',
                    }
                }
            })

            .state('profile.employee.locations', {
                url: 'ContactInfo/',
                views: {
                    'mainContent@profile.employee': {
                        templateUrl: require('./contactInfo.tpl.html'),
                        controller: 'EmployeeContactInfoController',
                        resolve: {
                            employeeWithLocations: ['$stateParams', 'employeeProfileService', function ($stateParams, service) {
                                return service.getEmployeeWithLocations($stateParams.EmployeeID);
                            }]
                        }
                    },
                }
            })

            .state('profile.employee.businessTasks', {
                url: 'businesstasks/',
                views: {
                    'mainContent@profile.employee': {
                        templateUrl: require('./EmployeeSystemBusinessTasks.tpl.html'),
                        controller: 'EmployeeSystemBusinessTasksController',
                        resolve: {
                            businessTasks: ['$stateParams', 'employeeProfileService', function ($stateParams, dataService) {
                                return dataService.getEmployeeBusinessTasks({ EmployeeID: $stateParams.EmployeeID });
                            }],
                            businessTaskSystemRoles: ['$stateParams', 'employeeProfileService', function ($stateParams, dataService) {
                                return dataService.getEmployeeBusinessTaskSystemRoles({ EmployeeID: $stateParams.EmployeeID });
                            }]
                        }
                    },
                }
            })

            .state('profile.employee.systemsOwned', {
                url: 'systemsOwned/',
                abstract: true,
            })



            .state('profile.employee.preAuthorizations', {
                url: 'preauthorizations/',
                views: {
                    'mainContent@profile.employee': {
                        templateUrl: require('./employeePreAuthorizations.tpl.html'),
                        controller: 'EmployeePreAuthorizationsController',
                        resolve: {
                            authorizedBusinessTasks: ['$stateParams', 'employeeProfileService', function ($stateParams, dataService) {
                                return dataService.getEmployeeAuthorizedBusinessTasks({ EmployeeID: $stateParams.EmployeeID });
                            }],
                            authorizedSystemRoles: ['$stateParams', 'employeeProfileService', function ($stateParams, dataService) {
                                return dataService.getActiveAuthorizedSystemAndRoles({ EmployeeID: $stateParams.EmployeeID });
                            }],
                            defaultEntitlementSysRoles: ['$stateParams', 'employeeProfileService', function ($stateParams, dataService) {
                                return dataService.getDefaultEntitlementSysRoles({ EmployeeID: $stateParams.EmployeeID });
                            }],
                        }
                    },
                }
            });
    }
})();
